export const locationsIDs = {
  changeLocationModal: 'change_city_modal',
  userLocationsList: 'manage_locations_locations_list',
  userLocationsListWatchingText: 'manage_locations_locations_list_watching_text',
  addNewLocationTextInput: 'change_city_modal_add_location_search_input',
  addNewLocationHeadingText: 'change_city_modal_add_location_heading_text',
  addNewLocationNameTextInput: 'change_city_modal_add_location_name_text_input',
  addNewLocationSearchResultRowItem: 'change_city_modal_add_location_search_result_',
  addNewLocationSaveButton: 'change_city_modal_add_location_save_button',
  addNewLocationCancelButton: 'change_city_modal_add_location_cancel_button',
  editLocationHeaderText: 'change_city_modal_edit_location_header_text',
  editLocationTextInput: 'change_city_modal_edit_location_text_input',
  editLocationSaveButton: 'change_city_modal_edit_location_save_button',
  editLocationCancelButton: 'change_city_modal_edit_location_cancel_button',
  editLocationSubHeadingText: 'change_city_modal_edit_subheading_text',
  editLocationFullName: 'change_city_modal_edit_location_fullname',
  headingText: 'change_city_modal_heading_text',
  searchSubHeadingText: 'change_city_modal_search_subheading_text',
  searchTextInput: 'change_city_modal_search_text_input',
  citiesListHeadingText: 'change_city_modal_cities_list_heading_text',
  searchResultsHeadingText: 'change_city_modal_search_resultes_heading_text',
  errorText: 'change_city_modal_error_text',
  fallbackText: 'change_city_modal_fallback_text',
};
